import React, { useContext, ChangeEvent } from "react";
import { Grid, Typography, TextField } from "@material-ui/core";
import { DesignContext } from "../../context/design";
import { LangContext } from "../../context/lang";

const EquipDesignComment = () => {
  const { lang } = useContext(LangContext);
  const { map, event, setevent } = useContext(DesignContext);
  const { feature } = event;

  const _onChangeComment = (e: ChangeEvent<HTMLInputElement>) => {
    let mapEvent: any = map;
    const draw = mapEvent._controls.find((control: any) => control.modes);
    draw.setFeatureProperty(feature?.id, "comment", e.target.value);
    setevent({
      ...event,
      feature: {
        ...feature,
        properties: { ...feature?.properties, comment: e.target.value },
      },
    });
  };

  return (
    <Grid item xs={12}>
      <Typography variant="subtitle1">{lang.data.comment}</Typography>
      <TextField
        variant="outlined"
        fullWidth
        multiline
        rows={3}
        value={feature?.properties?.comment ? feature.properties.comment : ""}
        onChange={_onChangeComment}
      />
    </Grid>
  );
};

export default EquipDesignComment;
